<template>  
    <section class="blockElement loginLoader-page">
		<loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></loader>
        <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
        <div class="container-fluid bglogin p-0">
            <div class="innerInclude">
                <div class="p_login d-flex align-items-center justify-content-center p-0">
                    <div class="row w-100">
                       <div class="col-12 col-md-4  text-center d-flex vh_100 flex-wrap blueBG beforeBG justify-content-center align-items-center">
                            <div class="titleArera Loginlogo">
                                <img src="../../../../static/fxView/images/logo-white.svg" alt="Icon">
                            </div>
                            <div class="loginNewSection  ">
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/Spreads.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent  text-left">
                                            <h3>Spreads</h3>
                                            <p>from 0.0 pips</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex ">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/Commission.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-right">
                                            <h3>$1 per</h3>
                                            <p>$100K Commission</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/TradingTools.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-left">
                                            
                                            <h3>A variety of </h3>
                                            <p>Trading Tools</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex ">
                                        <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/FastExecution.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-right">
                                            <h3>Ultra</h3>
                                            <p>Fast Execution</p>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/DepositBonus.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-left">
                                            <h3>100%</h3>
                                            <p>Deposit Bonus</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 
                            <div class="PortfoliosTitle"> 
                                <div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <p>{{ $t('welcomeMsg') }}</p>
                                            <img src="../../../../static/fxView/images/login-download.svg" alt="Banner">
                                            <h3>Competitive Trading Conditions </h3>
                                            <p>Benift from spreads as low as 0.0 pips on major fx pairs, and commission of $1 per $100,000 per side.</p>     
                                        </div>
                                         
                                    </div>
                                    <div class="clearfix"></div> 
                                </div>
                            </div>  -->
                            
                        </div>
                        <div class="col-12 col-md-8 d-flex vh_100 align-items-center">
                            <div class="sign_insec text-center">
                                <div class="subtitle">
                                    <h3>Reset Password</h3>
                                </div>
                                <div class="stepForm successfullyChange" v-show='displayMessage'>
                                    <div class="successChk"><feather type="check"></feather></div>
                                    <p>Password has been changed successfully.<br> Kindly click  <router-link to="/">  here </router-link>to login</p>
                                </div> 
                                <div class="stepForm restPass" v-show='!displayMessage'>
                                    <div class="form-group field-wrapper showIcon">
                                        <div class="position-relative">
                                        <input :type="inputtype" placeholder=" " v-model="password" class="float-field form-control" v-validate="{ required: true ,regex : /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/,'~])(?=.*[!@#$%^&*])\S{6,24}$/ , is: confirmPassword }" name="Password" :class="{ 'is-invalid': submitted && errors.has('password') }" ref="passwordInput" >
                                        <label for="password" class="float-label"> Password</label>
                                        <feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility('1')"></feather> 
                                        </div>
										<p class="error" v-for="error in errors.collect('Password')">
											<span v-show="error == 'The Password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
											<span v-show="error == 'The Password field format is invalid.'">{{$t('reg_passCharVal')}}</span>
										</p>
                                    </div> 
                                    <div class="form-group field-wrapper showIcon">
                                        <div class="position-relative">
                                        <input :type="inputtype1" placeholder=" " v-model="confirmPassword" class="float-field form-control" v-validate="{ required: true, confirmed: password}" name="confirmPassword" :class="{ 'is-invalid': submitted && errors.has('confirmPassword') }" ref="confirmPasswordInput" >
                                        <label for="password" class="float-label">Confirm password</label>
                                        <feather :type="iconType1" class="toggle-password" @click.prevent="switchVisibility('2')"></feather>
                                        </div>
										<p class="error" v-for="error in errors.collect('Confirm Password')"> 
											<span v-show="error == 'The Confirm Password field is required.'">The Confirm Password field is required</span>
											<span v-show="error == 'The Confirm Password field format is invalid.'">"Your password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^)"</span>
											<span v-show="error == 'The Confirm Password confirmation does not match.'">The entered passwords do not match. Please try again</span>
										</p>										
                                    </div> 
                                    <div class="clearfix"></div>
                                    <div class=" d-flex justify-content-between align-items-center submitButton w-100">
                                        <button class="prism_btn btn_sm" @click.prevent="submit()">Reset password</button>
                                        <div class="forgot_sec">
                                            <router-link :to="'/'" class="forgotpassword d-flex">
                                                <feather type="chevron-left" class="mr-1"></feather>Back to login page 
                                            </router-link>     
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3 contactsupport border-top pt-3 text-center">
                                    <h4 class="mb-3"> {{$t('rp_otherWayHelp')}}</h4>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="text-center">
                                            <a href=" https://direct.lc.chat/13047510/" class="prism_btn btn_sm" target="_blank"> {{$t('rp_chatWithUs')}}</a>
                                        </div>
                                        <div class="text-center mx-3">
                                             {{$t('rp_or')}}
                                        </div>
                                        <div class="text-center">
                                            <router-link to="#"  class="prism_btn btn_sm darkBG"> {{$t('rp_callUs')}}</router-link>
                                        </div>
                                    </div>
                                </div>   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import i18n from '@/plugins/lang/i18n';
    export default {
        name: 'Forgot-password',
        data() {
            return {
                "password" : "",
                "confirmPassword":"",
                submitted: false,
                inputtype1: 'password',
                inputtype: 'password',
                iconType : 'eye-off',
                iconType1 : 'eye-off',
                showpassword: false,
                showpassword1: false,
                displayMessage: false,
                pageLoader : false,
                response_msg : '',
                msg_type : '',
            }
        },
        methods:{
            ...mapActions({
                _runResetPasswordFromHash: types.RUN_USER_RESET_PASSWORD_FROM_HASH
            }),
            switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }else{
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }
                
            }, 
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "password": _that.password,
                                "cpassword": _that.confirmPassword,
                                "hash": _that.hash

                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runResetPasswordFromHash(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        },
        created(){
			this.hash = this.$route.query.hash
            //this.hash = this.$route.params.hash
            // console.log(params)            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/ResetPasswordFromHash.vue